import { APPROVAL_STATUS, type ApprovalStatus } from '@fdh/shared';

export const extractEmployerTaskCompletionDisplay = (
  submittedAt: string,
  taskDate: string,
): string | null => {
  const trimmed = submittedAt.trim();
  if (!trimmed) {
    return null;
  }
  const dateToken = trimmed.includes(' ') ? (trimmed.split(/\s+/)[0] ?? '') : '';
  const timeToken = trimmed.includes(' ') ? (trimmed.split(/\s+/)[1] ?? '') : trimmed;
  const hm = timeToken.slice(0, 5);
  if (!/^\d{2}:\d{2}$/.test(hm)) {
    return null;
  }
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateToken) && dateToken !== taskDate) {
    return `${dateToken} ${hm}`;
  }
  return hm;
};

export const shouldShowEmployerTaskCompletionTime = (
  status: ApprovalStatus,
  submittedAt: string,
): boolean => {
  if (!submittedAt.trim()) {
    return false;
  }
  if (status === APPROVAL_STATUS.APPROVED) {
    return true;
  }
  if (status === APPROVAL_STATUS.NEEDS_UPDATE) {
    return true;
  }
  if (status === APPROVAL_STATUS.PENDING) {
    return true;
  }
  return false;
};

export const submittedAtSortKey = (submittedAt: string): string => {
  const trimmed = submittedAt.trim();
  if (trimmed) {
    return trimmed;
  }
  return '0000-00-00 00:00';
};
